import React from 'react';

interface AdditonalFeatureProps {
  feature: string
}

const AdditonalFeature: React.FC<AdditonalFeatureProps> = ({ feature }) => {
  return (
    <>
      <p className="dot"></p>
      <p className="feature-title">{feature}</p>
    </>
  );
};

export { AdditonalFeature };
